import { ReactNode } from 'react';
import { CSSObjectWithLabel, GroupBase, OptionProps } from 'react-select';
import { DefaultTheme } from 'ui/selectv2/Themes';
import { mediumShadow, borderRadius } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const SelectCustomTheme = (errorMessage?: ReactNode) => {
  return {
    ...DefaultTheme(errorMessage),
    menu: (baseStyles: CSSObjectWithLabel) => ({
      ...baseStyles,
      ...mediumShadow,
      borderRadius: borderRadius.lg,
      width: pxToRem(300),
      right: '0px',
    }),
    option: (
      baseStyles: CSSObjectWithLabel,
      state: OptionProps<any, true, GroupBase<unknown>>,
    ) => ({
      ...DefaultTheme(errorMessage).option(baseStyles, state),
      width: 278,
      wordBreak: 'break-word',
    }),
  };
};
